import React, { lazy } from 'react';
import styled from 'styled-components';
import MapForm from '../../../../../../../MapForm';
import wkx from 'wkx';
import { Buffer } from 'buffer';
import ICellProps from '../../../ICellProps';
import { Dispatch } from 'redux';
import { actions as appActions } from 'reducer/app';
import { actions as messagesActions, IMessage } from 'reducer/messages';
import { connect } from 'react-redux';

import { getTripStops, updateTripStops } from 'api/handbooks/table';

interface IProps extends ICellProps {
  composite?: any;
  row?: any;
  config?: any;
  toggleSpinner: (value: boolean) => void;
}

interface IState {
  isMapShowing: boolean;
  tripStops?: any[];
}

const DataBlock = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  font-size: 12px;
  align-items: center;
  padding: 0 10px;
  cursor: pointer;
  color: #003a72;
`;

class TripStopCoords extends React.Component<IProps, IState> {
  state = {
    isMapShowing: false,
    tripStops: []
  };

  onShowEditDlg = async (): Promise<void> => {
    this.props.toggleSpinner(true);
    const tripStops = await getTripStops(this.props.row['id']);
    //console.log('tripsStops', tripStops);
    this.setState({ isMapShowing: true, tripStops: (tripStops && tripStops.stops || []) });
    this.props.toggleSpinner(false);
  };

  onCloseEditDlg = (): void => {
    this.setState({ isMapShowing: false });
  };

  onAccept = async (data: any): Promise<void> => {
    this.props.toggleSpinner(true);
    try {
      await updateTripStops(data.map((st: any) => ({ id: st.id, distance: st.distance })));
      this.setState({ isMapShowing: false });
    } catch (e) {

    }
    this.props.toggleSpinner(false);
  };

  getConnectedField = (fieldName: string): any => {
    const { config } = this.props;
    return this.props.row[fieldName];
  };

  getTrajectoryPoints = (): { lon: number; lat: number }[] => {
    const res: { lon: number; lat: number }[] = [];
    const { composite } = this.props;
    try {
      const wkbBuffer = new Buffer(
        this.getConnectedField(composite.trajectory),
        'hex'
      );
      const geom = wkx.Geometry.parse(wkbBuffer);
      const json = geom.toGeoJSON() as any;
      if (json && json.coordinates) {
        return json.coordinates.map((el: [number, number]) => ({
          lat: el[1],
          lon: el[0],
        }));
      }
    } catch (e) {
      console.log(e);
    }
    return res;
  };

  render() {
    return (
      <DataBlock onClick={!this.props.readonly ? this.onShowEditDlg : undefined}>
        Изменить
        {this.state.isMapShowing && (
          <MapForm
            {...(this.props as any)}
            point={undefined}
            trajectory={this.getTrajectoryPoints()}
            onClose={this.onCloseEditDlg}
            onAccept={this.onAccept}
            tripstops={this.state.tripStops || []}
          />
        )}
      </DataBlock>
    );
  }
  // state = {
  //   isMapShowing: false,
  // };

  // onShowEditDlg = (): void => {
  //   this.setState({ isMapShowing: true });
  // };

  // onCloseEditDlg = (): void => {
  //   this.setState({ isMapShowing: false });
  // };

  // // onAccept = (data: any): void => {
  //   try {
  //     const json = {
  //       type: 'LineString',
  //       coordinates: data.map((point: any) => [point.lon, point.lat])
  //     };
  //     const geom = wkx.Geometry.parseGeoJSON(json);
  //     this.props.onChange && this.props.onChange(geom.toEwkb().toString('hex'));
  //   } catch (e) {
  //     console.log('error', e);
  //   }

  //   this.setState({ isMapShowing: false });
  // };

  // getTrajectoryPoints = (): { lon: number; lat: number }[] => {
  //   const res: { lon: number; lat: number }[] = [];
  //   try {
  //     const wkbBuffer = new Buffer(this.props.value, 'hex');
  //     const geom = wkx.Geometry.parse(wkbBuffer);
  //     const json = geom.toGeoJSON() as any;
  //     if (json && json.coordinates) {
  //       return json.coordinates.map((el: [number, number]) => ({
  //         lat: el[1],
  //         lon: el[0],
  //       }));
  //     }
  //   } catch (e) {
  //     console.log(e);
  //   }
  //   return res;
  // };

  // render() {
  //   const { value } = this.props;
  //   return (
  //     <DataBlock onClick={this.onShowEditDlg}>
  //       {value ? 'Заполнено' : 'Пусто'}&nbsp;
  //       <Icon iconName={'Edit'} />
  //       {this.state.isMapShowing && (
  //         <MapForm
  //           {...(this.props as any)}
  //           point={undefined}
  //           trajectory={this.getTrajectoryPoints()}
  //           onClose={this.onCloseEditDlg}
  //           onAccept={this.onAccept}
  //         />
  //       )}
  //     </DataBlock>
  //   );
  // }
}


const mapActionToProps = (dispatch: Dispatch) => {
  return {
    toggleSpinner: (value: boolean) =>
      dispatch(appActions.toggleSpinner({ value: value })),
    addToStack: (message: IMessage) =>
      dispatch(messagesActions.addToStack(message)),
  };
};

export default connect(null, mapActionToProps)(TripStopCoords);
